<template>
  <div class="tab">
    <el-footer v-if="showManageFooter" class="tab__footer page__active_bar">
      <el-button
        v-if="$can('update', 'orgs')"
        class="page__active_button"
        id="submit"
        type="primary"
        @click="submit"
      >
        Сохранить
      </el-button>
      <el-button
        v-if="$can('delete', 'orgs')"
        class="page__active_button"
        id="delete"
        type="danger"
        @click="removeOrg"
      >
        Удалить
      </el-button>
    </el-footer>
    <main class="page_container">
      <el-form class="page__form" :model="form" ref="form" :rules="rules" label-position="right" label-width="150px">
        <el-form-item label="Наименование" prop="org_name">
          <el-input id="org_name" size="small" v-model="form.org_name" :readonly="!$can('update', 'orgs')" />
        </el-form-item>
      </el-form>
    </main>
  </div>
</template>

<script>
import { length, required } from "@/core/helpers/validators";
import { mapActions, mapState } from "vuex";

export default {
  name: "OrgEditTab",
  data() {
    return {
      dialog: false,
      form: {
        org_name: "",
      },
      rules: this.$can("update", "orgs")
        ? {
            org_name: [required(), length(4, 100)]
          }
        : null,
    };
  },
  computed: {
    ...mapState("org", ["org"]),
    showManageFooter() {
      return this.$can("update", "orgs") || this.$can("delete", "orgs");
    },
  },
  watch: {
    org(org) {
      this.form = Object.assign(this.form, org);
    },
  },
  methods: {
    ...mapActions("org", {
      save: "UPDATE_ORG",
      deleteUser: "DELETE_ORG",
    }),
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.save({
            id: this.org.id_org,
            data: {
              org_name: this.form.org_name
            },
          })
            .then(() => {
              this.$message({
                message: "Информация обновлена",
                type: "success",
              });
            })
            .catch(() => {
              this.$message({
                message: `При редактировании юр. лица произошла ошибка`,
                type: "error",
              });
            });
        }
        return valid;
      });
    },
    removeOrg() {
      this.$confirm("Вы точно хотите удалить юр. лицо?", "Удаление", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отмена",
        type: "warning",
      }).then(() => {
        this.deleteUser(this.org.id_org).then(() => {
          this.$message({
            message: "Юр. лицо удалено",
            type: "success",
          });
          window.history.back();
        });
      });
    }
  },
};
</script>
